import AppDao from '../AppDao';
/**
 * Fetches multiple {@link types} adjacent to an {@link object}, either parents or children
 *
 * @remarks
 *
 * RSE, 2024 01 — Moved from {@link AppDao} as that would cause access to objects before initialization, as it uses {@link AppDao} itself
 *
 * @param object to fetch adjacent from
 * @param types to fetch
 * @param direction `PathDirection.PARENT` or `PathDirection.CHILD`
 * @returns a promise of a {@link GetAdjacentResponse}
 */
export async function getMultipleAdjacentTypes(object, types, direction) {
    const promised = await Promise.all(types.map((type) => AppDao.getAdjacent(object, type, direction)));
    const res = promised.reduce((acc, cur, i) => {
        const accMessage = (acc.err?.message ?? '') + `${i}-${types[i]} ${cur.err?.message}`;
        const err = accMessage.length > 0 ? new Error(accMessage) : null;
        const data = acc.data ? (cur.data ? acc.data.concat(cur.data) : acc.data) : cur.data;
        return { err, data };
    }, { err: null, data: null });
    return res;
}
